import { gql } from '@apollo/client';

export const GET_USERS_BY_HILDA = gql`
  query UsersByHildaId($hildaId: BigInt!, $whereHilda: WhereHilda!) {
    usersByHildaId(hildaId: $hildaId) {
      id
      firstName
      lastName
      email
      dateOfBirth
      phoneNumber
      advisorFirmId
    }
    hilda(whereHilda: $whereHilda) {
      id
      name
      email
      taxId
      secondaryTaxId
      hildaTypeId
      accountTitle
      trustDocumentURL
      advisor {
        firstName
        lastName
      }
      address {
        streetAddress1
        city
        state
        zipCode
      }
    }
  }
`;
